import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Badge, Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import { RiEditFill } from "react-icons/ri";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import EditAdvertisementModal from "../../Components/Modals/EditAdvertisementModal.js";
import { useDeleteCategoryMutation } from "../../Data/services/categoryApi.js";
import {
  useDeleteAdvertisementMutation,
  useGetAllAdvertisementQuery,
} from "../../Data/services/advertisementApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// import { useDeleteBusinessTypeMutation, useGetAllBusinessTypeMutation, useGetAllBusinessTypeQuery } from "../../Data/services/businessTypeApi.js";
// import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// const CustomerBlockModal = lazy(() =>
//   import("../../Components/Modals/CustomerBlockModal.js")
// );

const AdvertisementManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  // const dummyData = [
  //   {
  //     id: 2,
  //     title: "Care Products",
  //     description:
  //       "NCREASE NUTRIENTS ABSORPTION - Solgar Digestive Enzymes, is a unique proprietary complex that helps support your digestive system and the absorption of your food. By taking 1-3 tablets of Solgar Digestive Enzymes a day, you are helping your body to digest the food you eat and absorb the nutrients you need",
  //     image_url:
  //       "https://www.totalwardrobecare.co.uk/cdn/shop/files/FP5A5261_0132x_4073b62f-cdc6-4046-9270-61b05aa9fa47_1200x.jpg?v=1726053877",
  //     cta_link: "https://www.totalwardrobecare.co.uk/collections/care-products",
  //     status: 1,
  //     createdAt: "2025-05-12T17:02:27.000Z",
  //     updatedAt: "2025-05-12T17:02:27.000Z",
  //   },
  //   {
  //     id: 1,
  //     title: "Solgar Digestive Enzymes Tablets",
  //     description:
  //       "NCREASE NUTRIENTS ABSORPTION - Solgar Digestive Enzymes, is a unique proprietary complex that helps support your digestive system and the absorption of your food. By taking 1-3 tablets of Solgar Digestive Enzymes a day, you are helping your body to digest the food you eat and absorb the nutrients you need",
  //     image_url:
  //       "https://m.media-amazon.com/images/I/71uX9rFgICL._AC_UF350,350_QL80_.jpg",
  //     cta_link:
  //       "https://www.amazon.co.uk/Solgar-Digestive-Enzymes-Tablets-Pack/dp/B000Z8X3WE",
  //     status: 1,
  //     createdAt: "2025-05-12T17:01:10.000Z",
  //     updatedAt: "2025-05-12T17:01:10.000Z",
  //   },
  // ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllAdvertisementQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deleteAdvertisement, { isLoading: isDeleting }] =
    useDeleteAdvertisementMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deleteAdvertisement(slug);
      // console.log(data);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "title",
      text: "Title",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "image_url",
      text: "Image",
      // sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        // return row.firstname + row.lastname;
        return (
          <img
            alt="user"
            src={cellContent || "images/no_image_available.png"}
            loading="lazy"
            width={62}
            height={62}
            className="rounded-circle object-fit-cover"
          />
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      headerAlign: "center",
      align: "center",
      // sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className="lc-2">
            {cellContent ? cellContent : "No description available"}
          </span>
        );
      },
    },
    {
      dataField: "cta_link",
      text: "CTA",
      // sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          <ToolTip placement={"top"} content={cellContent}>
            <a href={cellContent} target="_blank" rel="noreferrer">
              <Badge bg="primary" className="text-white">
                {cellContent ? "View" : "No Link"}
              </Badge>
            </a>
          </ToolTip>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <ToolTip placement={"top"} content={"Edit Category"}>
                <div
                  className={` d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 `}
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleEditModalOpen(true);
                  }}
                >
                  <span
                    className={`align-items-center d-flex justify-content-center `}
                  >
                    <RiEditFill />
                  </span>
                  {/* <span>Edit</span> */}
                </div>
              </ToolTip>

              <ToolTip placement={"top"} content={"Delete Category"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleDeleteModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center`}>
                    <MdDeleteForever />
                  </span>
                  {/* <span>Delete</span> */}
                </div>
              </ToolTip>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditAdvertisementModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Advertisement Management"} classes="text-black" />
        </div>

        {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add Advertisement"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        }
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
                // refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvertisementManagementScreen;
